import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';

@Component({
  selector: 'app-group-on-demend-req',
  templateUrl: './group-on-demend-req.component.html',
  styleUrls: ['./group-on-demend-req.component.scss'],
})
export class GroupOnDemendReqComponent  {

  loader:boolean;
  fDate;
  startdate;
  allServices;
  allIndServices;
  singleService;
  categoryId;
  serviceName;
  serviceId;
  dateFormat;
  subsId;
  doorNbr;
  flatName;
  flatNo;
  url;
  appt:boolean;
  subscriptions:any=[];
  subsDetail:any = [];
  custItemObj:any=[];
  constructor(   private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService,private bottomSheet: MatBottomSheet) { }

ionViewWillEnter(){
  this.dateFormat = this.auth.getDateformat();
  var sub =JSON.parse(sessionStorage.getItem('notify'));
  this.url = window.location.href;
  if(this.url.includes('group-On-Demand1')){
    sub.map(res=>{
        this.subsDetail.push(res[0].packageId)
    })
  }else{
    sub.map(res=>{
      this.subsDetail.push(res.id)
    })
  }
  this.getSingleService();
  this.getSubsDetails();
}

getSubsDetails(){  
 var post = {
  "subscriptions":this.subsDetail
 }
  this.service.getGroupSubs(post).subscribe((res:any)=>{
    this.subscriptions = res;
    this.subscriptions.map(res=>{
      Object.assign(res,{clicked:true})
    }) 
    this.custItemObj = this.subscriptions.filter(res => res.clicked == true);
  })
}

    returnDate(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
     let month = data.getMonth() + 1;
     month = month < 10 ? '0' + month : month;
     let year = data.getFullYear();  
     return year + '-' + month + '-' + date;
   }

    startDate1(){
      this.fDate=this.returnDate(this.startdate);
    }

    getSingleService(){
      this.service.getAllItems().subscribe((res: any) => {
     this.allServices=res;
     this.allIndServices= this.allServices.filter(res=>{return res.packageInd==false})
    })
 }

    openBottomSheetService(): void { 
      // this.singleService = this.allIndServices.filter(res=>res.itemCategoryId==this.categoryId)
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.allIndServices,
      });
      dialogRef.afterDismissed().subscribe(res => {   
          this.serviceName=res.name;
          this.serviceId=res.id;      
      });    
    
    }

    
  sendId(data){
    data.clicked = ! data.clicked;
    this.custItemObj = this.subscriptions.filter(res => res.clicked == true);
    }

  cancel(){
    if(this.url.includes('group-On-Demand1')){
      this.router.navigate(['/monthly-Tracker']) 
    }else{
    this.router.navigate(['/vendor-subs'])
  }   
  }

 
    create() {
        this.loader = true;
        var z = this.custItemObj.length;
        if(z>0){
          this.custItemObj.map((data,i)=>{
           var post={   
          "custName":data.custName,
          "contactNbrMob":data.contactNbrMob,
          "custItemId":data.custItems[0].id,
          "categoryId":data.categoryId,     
          "providerServiceId":this.serviceId,     
          "activeInd": true,
          "serviceProviderId":localStorage.getItem('organizationId'),
          "cost":0,
          "payTotal":0,    
          "packageInd":false,
          "subscriptionInd":false,
          "requestorId":data.requestorId,
          "apptDate": this.fDate,  
          "apptTime":"06:00",
          "apptEndTime": "12:00",  
          "packageId":data.id,
          "type":1,
          "status": 1,
          "vendorId":data.vendorId,
          "serviceContractorId":data.serviceContractorId,
          "requestDates": [
            {
              "apptDate": this.fDate,  
              "apptTime":"06:00",
              "apptEndTime": "12:00",        
              "status": 1
            }],
          "address":{
            "houseNbr": data.houseNbr,
            "cityId": data.cityId,
            "stateId": data.stateId,
            "regionId":data.regionId,
            "zipcode":data.zipcode,
            "lat": data.lat,
            "lon": data.lon,
            "type": 1,
            "appt":data.appt
          }      
        
        } 
        if(!this.appt){
          Object.assign(post.address,{"doorNbr":data.doorNbr,"street": data.street})
        }else{
          Object.assign(post.address,{"flatNo":data.flatNo, "flatName":data.flatName,})
        }      
          this.service.createSingleReq(post).subscribe(res=>{
            if(i == z-1){
              this.loader = false;
              this.url = window.location.href;
                if(this.url.includes('group-On-Demand1')){
                this.router.navigate(['/monthly-Tracker']) 
                this.custItemObj="";
                }else{
                this.router.navigate(['/vendor-subs'])
                this.custItemObj="";
              }
            }
            this.handler.res("Request Created Successfully");
          })        
        })
        }else{
          this.loader = false;
          this.handler.res("Please Select Customer Items");
        }
       
   
     
     
    }

    ionViewWillLeave(){
      this.serviceName="";
      this.serviceId="";
      this.fDate="";
      sessionStorage.removeItem('notify');
      this.subsDetail=[];
    }
}
